export const paymentTableData = [
    {
        "id": 1,
        "invoice": "#987456",
        "client": {
            "name": "Alexandra Della",
            "email": "alex.della@outlook.com",
            "img": "/images/avatar/1.png"
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "$249.99 USD",
        "date": "2023-04-25, 03:42PM",
        "status": {
            "content": "Complted",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 2,
        "invoice": "#987456",
        "client": {
            "name": "Nancy Elliot",
            "email": "nancy.elliot@outlook.com",
            "img": ""
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "	$120.50 USD",
        "date": "2023-05-20, 12:23PM",
        "status": {
            "content": "Declined",
            "color": "bg-soft-danger text-danger"
        }
    },
    {
        "id": 3,
        "invoice": "#741258",
        "client": {
            "name": "Green Cute",
            "email": "green.cute@outlook.com",
            "img": "/images/avatar/2.png"
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "	$300.50 USD",
        "date": "2023-01-02, 10:36AM",
        "status": {
            "content": "Complted",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 4,
        "invoice": "#321456",
        "client": {
            "name": "Henry Leach",
            "email": "henry.leach@outlook.com",
            "img": ""
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "$249.99 USD",
        "date": "22023-04-25, 04:22PM",
        "status": {
            "content": "Unpaid",
            "color": "bg-soft-warning text-warning"
        }
    },
    {
        "id": 5,
        "invoice": "#357895",
        "client": {
            "name": "Marianne Audrey",
            "email": "marine.adrey@outlook.com",
            "img": "/images/avatar/3.png"
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "$150.00 USD",
        "date": "2023-02-15, 05:23PM",
        "status": {
            "content": "Complted",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 6,
        "invoice": "#321456",
        "client": {
            "name": "Alexandra Della",
            "email": "alex.della@outlook.com",
            "img": "/images/avatar/4.png"
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "$249.99 USD",
        "date": "2023-04-25, 11:43AM",
        "status": {
            "content": "Complted",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 7,
        "invoice": "#987456",
        "client": {
            "name": "Nancy Elliot",
            "email": "nancy.elliot@outlook.com",
            "img": "/images/avatar/5.png"
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "$120.50 USD",
        "date": "2023-05-20, 03:46PM",
        "status": {
            "content": "Unpaid",
            "color": "bg-soft-warning text-warning"
        }
    },
    {
        "id": 8,
        "invoice": "#741258",
        "client": {
            "name": "Green Cute",
            "email": "green.cute@outlook.com",
            "img": "/images/avatar/6.png"
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "$300.00 USD",
        "date": "2023-01-02, 02:35PM",
        "status": {
            "content": "Complted",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 9,
        "invoice": "#357895",
        "client": {
            "name": "Henry Leach",
            "email": "henry.leach@outlook.com",
            "img": ""
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "$249.99 USD",
        "date": "2023-04-25,06:35PM",
        "status": {
            "content": "Unpaid",
            "color": "bg-soft-warning text-warning"
        }
    },
    {
        "id": 10,
        "invoice": "#521456",
        "client": {
            "name": "Alexandra Della",
            "email": "alex.della@outlook.com",
            "img": "/images/avatar/4.png"
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "$249.99 USD",
        "date": "2023-04-25, 11:43AM",
        "status": {
            "content": "Complted",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 11,
        "invoice": "#117456",
        "client": {
            "name": "Alexandra Della",
            "email": "alex.della@outlook.com",
            "img": ""
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "$249.99 USD",
        "date": "2023-04-25, 03:42PM",
        "status": {
            "content": "Complted",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 12,
        "invoice": "#351457",
        "client": {
            "name": "Alexandra Della",
            "email": "alex.della@outlook.com",
            "img": "/images/avatar/4.png"
        },
        "transaction": "#SDEG4589SE1E",
        "amount": "$249.99 USD",
        "date": "2023-04-25, 11:43AM",
        "status": {
            "content": "Complted",
            "color": "bg-soft-success text-success"
        }
    },
]